import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Report } from '../../models/report.model';
import { LesPlusEditModeComponent } from './les-plus-edit-mode/les-plus-edit-mode.component';
import { LesPlusReadModeComponent } from './les-plus-read-mode/les-plus-read-mode.component';
import { PButtonComponent } from '../../../shared/design-system/atoms/p-button/p-button.component';
import { SectionComponent } from '../section/section.component';

@Component({
  selector: 'app-les-plus',
  templateUrl: './les-plus.component.html',
  styleUrls: ['./les-plus.component.scss'],
  standalone: true,
  imports: [
    LesPlusEditModeComponent,
    LesPlusReadModeComponent,
    PButtonComponent,
    SectionComponent,
  ],
})
export class LesPlusComponent {
  @Input() perks!: Report.Perk;
  @Input() isLoading = false;

  perksInternal!: Report.Perk;

  @Output() perksChanged = new EventEmitter<Report.Perk>();
  @Output() perksEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  onPerksChanged(perks: Report.Perk): void {
    this.perksInternal = perks;
  }

  onSaveSection(): void {
    this.perksChanged.emit(this.perksInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.perksEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }
}
